'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _adapters = require('../adapters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    id: 'com.ewaypayments',

    form: [{ type: 'string', name: 'customerId' }],

    // @see List of countries in https://eway.io/ (though some countries are not supported by the API version we use)
    countries: [
    //        'AU', 'HK', 'MY', 'NZ', 'SG'
    'AU'],

    fields: [],

    formValuesToMerchant: _adapters.simpleFormValuesToMerchant,
    merchantToFormValues: _adapters.simpleMerchantToFormValues,
    keyToMerchant: JSON.parse,
    merchantToKey: _stringify2.default,

    ranking: 3
};